import {
    ChangeDetectionStrategy,
    Component,
    HostBinding,
    Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Gable — the PayHOA AI assistant mascot. A small, cute lil house guy with
 * eyes that blink occasionally. Renders as inline-block; sized via the `size`
 * input or the `--gable-size` CSS custom property on the host.
 *
 * Intentionally minimal: no mouse tracking, no click reactions, no particles.
 * Just a happy little house mascot for thinking/streaming states.
 */
@Component({
    selector: 'app-ai-gable-mascot',
    templateUrl: './ai-gable-mascot.component.html',
    styleUrls: ['./ai-gable-mascot.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class AiGableMascotComponent {
    /** Square size in px. Default 28. */
    @Input() size = 28;

    /** When true, a little thought-bubble cluster pops above his head. */
    @Input() thinking = false;

    @HostBinding('style.--gable-size.px') get hostSize(): number {
        return this.size;
    }

    @HostBinding('class.is-thinking') get hostThinking(): boolean {
        return this.thinking;
    }
}
